import React from 'react';

function Author(props){
    return(
        <p id="author">- {props.author}</p>
    )
}

export default Author;